"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedStates = void 0;
var EmbedStates;
(function (EmbedStates) {
    EmbedStates["EMBED_ONBOARDING"] = "embedOnboarding";
    EmbedStates["EMBED_PAY"] = "embedPay";
    EmbedStates["EMBED_PAY_SLC"] = "embedPaySlc";
})(EmbedStates || (exports.EmbedStates = EmbedStates = {}));
